import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=49313db0&scoped=true"
var script = {}
import style0 from "./Notify.vue?vue&type=style&index=0&id=49313db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49313db0",
  null
  
)

export default component.exports